/**
 * mutates the applicant.visits.data property with the data given and
 * sets the applicant.visits.retrieved = true
 */
export const getApplicantVisits = (state, data) => {
  state.applicant.visits.data = data;
  state.applicant.visits.retrieved = true;
};
